import {NgModule} from '@angular/core';
import {CommonModule as NGCommonModule} from '@angular/common';
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import { MyDateRangePickerModule } from 'mydaterangepicker';

import {CommonRoutingModule} from './common-routing.module';
import {AuthGuard} from './auth/auth.guard';
import {AuthenticationService} from './auth/auth.service';
import {HttpClient} from './http.client';
import {TranslateModule} from '@ngx-translate/core';
import {LatitudeUIModule} from 'latitude-ui';

import {LoginComponent} from './login/login.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {BaseMapComponent} from './base-map/base-map.component';
import { CustomDatepickerComponent } from './custom-datepicker/custom-datepicker.component';

import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {MapContextService} from 'app/common/map-context.service';

import {ToMilesPipe} from './pipes/toMiles.pipe';
import {CityComponent} from '../real-time/city/city.component';
import {LayerService} from './services/layer.service';
import {MvtService} from './services/mvt.service';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

const components = [
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    BaseMapComponent,
    ToMilesPipe,
    CityComponent,
    CustomDatepickerComponent
];

@NgModule({
    imports: [
        NGCommonModule,
        HttpModule,
        FormsModule,
        CommonRoutingModule,
        TranslateModule,
        LatitudeUIModule,
        PerfectScrollbarModule,
        MyDateRangePickerModule
    ],
    declarations: components,
    providers: [
        AuthGuard,
        AuthenticationService,
        MapContextService,
        HttpClient,
        LayerService,
        {
            provide: MvtService,
            useClass: MvtService
        },
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ],
    exports: [...components, LatitudeUIModule, TranslateModule, PerfectScrollbarModule]
})
export class CommonModule {
}



// WEBPACK FOOTER //
// ./src/app/common/common.module.ts